import type { ICRMCasesResponse } from '../../../Interfaces/ICRMCase';
import { PBTCrmCasesActionType } from './action-types';

interface IRequestCrmCasesAction {
  type: typeof PBTCrmCasesActionType.REQUEST_CRM_CASES;
  payload: {
    pageNumber: number;
    pageSize: number;
    searchString: string;
  };
}

interface IReceiveCrmCasesAction {
  type: typeof PBTCrmCasesActionType.RECEIVE_CRM_CASES;
  payload: { response: ICRMCasesResponse; searchString: string };
}

interface ISendCrmCasesErrorAction {
  type: typeof PBTCrmCasesActionType.CRM_CASES_ERROR;
  payload: string;
}

export type PBTCrmCasesAction = IRequestCrmCasesAction | IReceiveCrmCasesAction | ISendCrmCasesErrorAction;

export const requestCrmCases = (
  pageNumber = 1,
  pageSize = 15,
  searchString = ''
): IRequestCrmCasesAction => ({
  type: PBTCrmCasesActionType.REQUEST_CRM_CASES,
  payload: { pageNumber, pageSize, searchString },
});

export const receiveCrmCases = (response: ICRMCasesResponse, searchString = ''): IReceiveCrmCasesAction => ({
  type: PBTCrmCasesActionType.RECEIVE_CRM_CASES,
  payload: { response, searchString },
});

export const sendCrmCasesError = (errorMessage: string): ISendCrmCasesErrorAction => ({
  type: PBTCrmCasesActionType.CRM_CASES_ERROR,
  payload: errorMessage,
});
